





































































































import DatePicker from '@ssp/ss-commons-front/src/components/DatePicker.vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    DatePicker,
  },
})
export default class FilterPeople extends Vue {
  filters = {
    name: '',
    period: [null, null] as Array<string | null>,
    paid: '',
    coordinator: '',
    instructor: '',
  };

  filterType: string = 'name';

  clearFilter() {
    this.filterType = 'name';
    this.filters.name = '';
    this.triggerFilter();
  }

  triggerFilter() {
    this.$emit('on-filter', this.filterType, this.filters[this.filterType]);
  }
}
